module.exports = __webpack_public_path__ + "img/product-2.9dc6cce7.png";